import { useSelector } from 'react-redux';

import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import LoginIcon from '@mui/icons-material/Login';
import HomeIcon from '@mui/icons-material/Home';
import SignupIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';

import { selectIsUserAuthenticated } from '../Auth/selector';

const MobileMenu = (props) => {
  const isUserAuthenticated = useSelector(selectIsUserAuthenticated);

  const { mobileMoreAnchorEl, handleMobileMenuClose, mobileMenuId } = props;
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const loggedInMenuItems = [(
    <MenuItem key="home">
      <IconButton
        aria-label="Go to home"
        color="inherit"
      >
        <HomeIcon />
      </IconButton>
      <Link href="/dashboard" color="inherit" underline="none">Dashboard</Link>
    </MenuItem>
  ), (
    <MenuItem key="logout">
      <IconButton
        aria-label="Logout"
        color="inherit"
      >
        <LogoutIcon />
      </IconButton>
      <Link href="/logout" color="inherit" underline="none">Logout</Link>
    </MenuItem>
  )];

  const loggedOutMenuItems = [(
    <MenuItem key="login">
      <IconButton
        aria-label="Log in"
        color="inherit"
      >
        <LoginIcon />
      </IconButton>
      <Link href="/login" color="inherit" underline="none">Login</Link>
    </MenuItem>
  ), (
    <MenuItem key="signup">
      <IconButton
        aria-label="Sign up as pet owner or pet sitter"
        color="inherit"
      >
        <SignupIcon />
      </IconButton>
      <Link href="/signup" color="inherit" underline="none">Sign Up</Link>
    </MenuItem>
  )];

  return (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {isUserAuthenticated !== false ? loggedInMenuItems : loggedOutMenuItems}
    </Menu>
  );
}

export default MobileMenu;
